exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dy-project-select-tree[data-v-43399082]{\n  display:-webkit-box;\n  display:-ms-flexbox;\n  display:flex;\n  -webkit-box-orient:vertical;\n  -webkit-box-direction:normal;\n      -ms-flex-direction:column;\n          flex-direction:column;\n  overflow:hidden;\n  height:100%\n}\n.dy-project-select-tree .dy-tree[data-v-43399082]{\n  -webkit-box-flex:1;\n      -ms-flex:1;\n          flex:1;\n  overflow:auto\n}", ""]);

// exports
